import notificationsService from '@classes/notifications_service'
import { notificationsIcons } from '@constants/notifications'
import PropTypes from 'prop-types'

const Notification = ({ id, title, message, type, timer }) => (
  <li className={`notification ${type}`} data-purpose="notification_section">
    <span className="material-icons notification-icon">{notificationsIcons[type]}</span>
    <span className="notification-content">
      <span className="notification-title" data-purpose="title">
        {title}
      </span>
      <span className="notification-message" data-purpose="message">
        {message}
      </span>
    </span>
    <span
      className="notification-close"
      onClick={() => {
        notificationsService.remove(id)
      }}
    >
      <svg>
        <circle r="18" cx="20" cy="20" style={{ animationDuration: `${timer / 1000}s` }} />
      </svg>
      <span className="material-icons notification-icon-close">close</span>
    </span>
  </li>
)

Notification.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  timer: PropTypes.number.isRequired,
}

export default Notification
